import { LocationUserManagement } from '../components/LocationUserManagement/LocationUserManagement';

export const LocationUserManagementPage = () => {
  return <LocationUserManagement />;
};
